export enum FileBrowserContextMenuActionEnum {
  DOWNLOAD = 'download',
  RENAME = 'rename',
  DELETE = 'delete',
  UPLOAD_FILE = 'upload_file',
  RELOAD = 'reload',
}
